import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { FeatureFlagsService } from './feature-flags.service';

/**
 * Provides LaunchDarkly feature flags at the root level.
 * Register in app.config.ts so the service is available app-wide to all subapps.
 */
export function provideFeatureFlags(): EnvironmentProviders {
  return makeEnvironmentProviders([
    FeatureFlagsService,
    provideAppInitializer(() => inject(FeatureFlagsService).startAuthListener()),
  ]);
}
